import { createEvent } from "library/local-events/index.mjs"

export const RetrievingTree = createEvent("RetrievingTree")
export const RetrievedTree = createEvent("RetrievedTree")
